import API_CONFIG from '../config/api.config';

const PLACEHOLDER = 'profile.png';

function mediaOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://ssvassgje.in';
}

function cleanFilename(filename) {
  if (!filename) {
    return '';
  }
  return String(filename).replace(/^.*[\\/]/, '').trim();
}

export function visitorMediaUrl(kind, filename) {
  const name = cleanFilename(filename);
  if (!name || name === PLACEHOLDER) {
    return '';
  }
  if (filename.startsWith('http')) {
    return filename;
  }
  return `${mediaOrigin()}${API_CONFIG.UPLOADS_BASE}/${kind}/${name}`;
}

export function visitorMediaFallbackUrl(kind, filename) {
  const name = cleanFilename(filename);
  if (!name || name === PLACEHOLDER || String(filename).startsWith('http')) {
    return '';
  }
  const legacyBase = API_CONFIG.LEGACY_UPLOADS_BASE.startsWith('http')
    ? API_CONFIG.LEGACY_UPLOADS_BASE
    : `${mediaOrigin()}${API_CONFIG.LEGACY_UPLOADS_BASE}`;
  return `${legacyBase}/${kind}/${name}`;
}

async function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function resolveVisitorPhotoSrc(filename) {
  const urls = [
    visitorMediaUrl('profile_image', filename),
    visitorMediaFallbackUrl('profile_image', filename)
  ].filter(Boolean);

  for (const url of urls) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        continue;
      }
      const blob = await response.blob();
      if (blob.size < 32) {
        continue;
      }
      if (blob.type && !blob.type.startsWith('image/') && blob.type !== 'application/octet-stream') {
        continue;
      }
      return await blobToDataUrl(blob);
    } catch {
      // try next candidate
    }
  }
  return '';
}
